import { DSIcon, type DSIconName } from '@eiv2/design-system';
import { getStatusLabel } from '../services/labels';

export interface StatusChipProps {
  status: string | null | undefined;
}

type StatusTone = {
  className: string;
  icon: DSIconName;
};

function toneFor(status: string | null | undefined): StatusTone {
  if (status === 'converted') {
    return {
      className: 'bg-feedback-success/20 text-feedback-success',
      icon: 'TickCircle'
    };
  }

  if (status === 'abandoned') {
    return {
      className: 'bg-feedback-danger/20 text-feedback-danger',
      icon: 'Warning2'
    };
  }

  if (status === 'active') {
    return {
      className: 'bg-brand-primary-3-20 text-brand-primary-3',
      icon: 'Flash'
    };
  }

  return {
    className: 'bg-gray-3 text-dark-3',
    icon: 'InfoCircle'
  };
}

export function StatusChip({ status }: StatusChipProps) {
  const tone = toneFor(status);

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center gap-1 rounded-2xl py-0.5 pr-2 pl-1.5 ${tone.className}`}
    >
      <DSIcon aria-hidden name={tone.icon} size={12} />
      <span className="whitespace-nowrap text-[12px] font-medium leading-[18px]">
        {getStatusLabel(status)}
      </span>
    </span>
  );
}
